import React, {FC} from 'react';
import styled from 'styled-components';
import SidebarWrap from "./SidebarWrap";
import {SidebarData} from "../Data/SidebarData";
import Submenu from "./Submenu";
import ToggleButton from "./ToggleButton";
import CompetitionSelector from "./CompetitionSelector";
import {useAuth} from "../config/AuthContext";

const SidebarNav = styled.div<{ $sidebar: boolean }>`
    background-color: #162916;
    width: 15rem;
    height: 100vh;
    margin: 0 auto;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
`;

const Sidebar: FC = () => {
    const [sidebar, setSidebar] = React.useState(true);
    const showSidebar = () => setSidebar(!sidebar);
    const {isAdmin, isLoggedIn} = useAuth();

    return (
        <>
            <ToggleButton sidebar={sidebar} showSidebar={showSidebar}/>
            <SidebarNav $sidebar={sidebar}>
                <SidebarWrap>
                    {SidebarData.map((item, index) => {
                        const inDevEnv = process.env.REACT_APP_ENV === 'local';
                        if (item.development && !inDevEnv) return null;
                        if (item.adminOnly && !isAdmin) return null;
                        if (item.loggedInOnly && !isLoggedIn) return null;
                        return <Submenu item={item} key={index}/>;
                    })}
                </SidebarWrap>
                <CompetitionSelector/>
            </SidebarNav>
        </>
    );
}

export default Sidebar;
